export default `
    <div id="#= data.id || "" #" class="#: data.classes || "" # #=data.bsc||""#" style="#=data.style || ""#">
        #= data.contents ? data.contents : "" #
    </div>
`;
